import { AxiosError } from 'axios';
import React, { createContext, useContext, useState, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import GlobalErrorFallback from './GlobalErrorFallback';

interface IErrorCtxValue {
	error: AxiosError | null;
	setError: React.Dispatch<React.SetStateAction<AxiosError | null>>;
}

const ErrorCtx = createContext<IErrorCtxValue | undefined>(undefined);

interface IErrorCtxProviderProps {
	children: React.ReactNode;
}

export const ErrorCtxProvider: React.FC<IErrorCtxProviderProps> = ({
	children
}) => {
	const [error, setError] = useState<AxiosError | null>(null);

	const value = useMemo(() => ({ error, setError }), [error]);

	return (
		<ErrorCtx.Provider value={value}>
			<ErrorBoundary fallbackRender={GlobalErrorFallback}>
				{children}
			</ErrorBoundary>
		</ErrorCtx.Provider>
	);
};

export const useErrorCtx = (): IErrorCtxValue => {
	const context = useContext(ErrorCtx);
	if (!context) throw new Error('ErrorCtxProvider is missing');
	return context;
};
